import { Link } from 'react-router-dom';
import { LegalLayout, Lead, Section, P, Bullets } from '../legal/LegalLayout';

// Child safety standards for the Matou app (Google Play requires a public
// page for apps with chat / user-generated content). Content mirrors
// matou-app/docs/mobile/CHILD_SAFETY_STANDARDS.md in the site's voice.

export default function ChildSafety() {
  return (
    <LegalLayout title="Child safety" updated="29 August 2026">
      <Lead>
        These standards apply to the Matou app and to every community that
        runs it. The app carries chat, notices and other content written by
        members, so we say plainly here what is never acceptable, how to
        report it, and what happens when you do.
      </Lead>

      <Section title="Our commitment">
        <P>
          We do not allow the sexual exploitation or abuse of children in any
          form, anywhere in the app. Every report is taken seriously.
        </P>
      </Section>

      <Section title="What is prohibited">
        <Bullets
          items={[
            'Child sexual abuse material (CSAM), or any sexual content involving minors.',
            'Sexual solicitation of minors, grooming, or exploitation.',
            'Content that encourages self-harm, suicide, or violence against minors.',
            'Harassment, bullying, hate speech, threats, or predatory behaviour.',
            'Sharing a minor’s — or anyone’s — personal information without consent.',
            'Content that facilitates trafficking, abuse, or exploitation.',
            'Any illegal content involving minors.',
          ]}
        />
      </Section>

      <Section title="How to report">
        <P>
          Report immediately to{' '}
          <a
            href="mailto:sysadmin@matou.nz"
            className="text-matou-teal-deep underline hover:text-matou-teal-medium"
          >
            sysadmin@matou.nz
          </a>{' '}
          and to your community&apos;s administrators. Include what happened
          and when, the channel or notice it happened in, screenshots or
          message text if it is safe to provide them, and the display names
          involved.
        </P>
      </Section>

      <Section title="Moderation and enforcement">
        <P>
          Every Matou community is administrator-moderated. Administrators can
          remove or restrict content and channels, restrict chat
          participation, and suspend or remove members. Content in the app is
          cryptographically signed, so a record of who posted what can be
          preserved for investigation.
        </P>
      </Section>

      <Section title="How we respond">
        <P>
          Reports involving minors, CSAM, or immediate threats come first.
          Where we or a community become aware of possible CSAM or the
          exploitation of a minor, we restrict access to the content and the
          accounts involved, preserve evidence as the law requires, and report
          to the appropriate authorities where legally required or
          appropriate.
        </P>
      </Section>

      <Section title="Age">
        <P>
          The Matou app is intended for adults, eighteen and over. Communities
          must not knowingly admit members under that age.
        </P>
      </Section>

      <Section title="Data">
        <P>
          Handling a safety report can involve processing limited personal
          data — message text and identifiers — for safety and compliance
          purposes only. Our{' '}
          <Link
            to="/privacy"
            className="text-matou-teal-deep underline hover:text-matou-teal-medium"
          >
            Privacy policy
          </Link>{' '}
          explains how we handle data generally.
        </P>
      </Section>

      <Section title="Contact">
        <P>
          For any child-safety concern:{' '}
          <a
            href="mailto:sysadmin@matou.nz"
            className="text-matou-teal-deep underline hover:text-matou-teal-medium"
          >
            sysadmin@matou.nz
          </a>
          .
        </P>
      </Section>
    </LegalLayout>
  );
}
